import styled from "styled-components";

export const Banner = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].positive_Sub,
    padding: `${theme.spacing.small} ${theme.spacing.medium}`,
    marginBottom: theme.spacing.large,
    boxShadow: "0px 1px 16px rgba(0, 0, 0, 0.05)",
    borderBottomRightRadius: theme.cornerRadius.small,
    borderBottomLeftRadius: theme.cornerRadius.small,
    display: "flex",
    alignItems: "center",
}));

export const BannerCode = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
}));

export const BannerContentContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: `0px ${theme.spacing.small}`,
    marginTop: theme.spacing.xxxSmall,
}));
